import Grid from "@mui/material/Grid";
import WorkItemSearchFieldWorkItem from "../fields/WorkItem";
import WorkItemSearchFieldStatus from "../fields/WorkItemSearchFieldStatus";
import WorkItemSearchFieldWorkspace from "../fields/WorkItemSearchFieldWorkspace";
import WorkItemSearchFieldResource from "../fields/WorkItemSearchFieldResource";
import WorkItemSearchFieldContentType from "../fields/WorkItemSearchFieldContentType";
import Button from "@mui/material/Button";
import { SetStateAction, useState } from "react";
import useWorkItemAutocompleteResource, { GetAutocompleteResult } from "hooks/work-items/useWorkItemAutocompleteResource";
import useWorkItemListOfValues from "hooks/work-items/useWorkItemListOfValues";
import useWorkItemPossibleStatus from "hooks/work-items/useWorkItemPossibleStatus";
import { WorkItemSearchCriteria } from "hooks/work-items/useWorkItem";
import WorkItemSearchFieldResponsibility from "../fields/WorkItemSearchFieldResponsibility";
import { BulkUpdateModes } from "../WorkItemBulkUpdate";

interface IBulkUpdateSearchStatus {
    mode: BulkUpdateModes,
    onClearSearch: () => void,
    onSearch: (payload: WorkItemSearchCriteria) => void
}

const BulkUpdateSearch = (props: IBulkUpdateSearchStatus) => {

    const [workItem, setWorkItem] = useState('');
    const [resource, setResource] = useState('');
    const [userId, setUserId] = useState('');
    const [workspaces, setWorkspaces] = useState<number[]>([]);
    const [workItemStatuses, setWorkItemStatuses] = useState<number[]>([]);
    const [contentTypes, setContentTypes] = useState<number[]>([]);
    const [useOrOperator, setUseOrOperator] = useState<boolean>(true);
    const [includeChildren, setIncludeChildren] = useState<boolean>(true);
    const [onlyAsPrimaryResource, setOnlyAsPrimaryResource] = useState<boolean>(true);
    const [workitemLOVs, loadingWorkItemLOVs, errorWorkItemLOVs] = useWorkItemListOfValues();
    const { WorkItemSearchStatuses, WorkItemStatusLoading, WorkItemResourcesSearchStatuses } = useWorkItemPossibleStatus();
    const [workItemResponsibilities, setWorkItemResponsibilities] = useState<number[]>([]);
    const [resources, loadingResources, errorResources, setResources] = useWorkItemAutocompleteResource(resource);
    const [openEmptySearchConfirmation, setOpenEmptySearchConfirmation] = useState<boolean>(false);
    const [isPrimaryResource, setIsPrimaryResource] = useState<boolean>(false);

    const onChangeResource = (e: any, newValue: string | GetAutocompleteResult | null) => {
        if (typeof newValue === 'string' || newValue === null) {
            setUserId(newValue ? newValue as string : '');
        }
        else {
            setUserId(newValue.userId);
        }
        setResources(null);
    }

    const handleIsPrimaryResource = (isChecked: boolean) => {
        setIsPrimaryResource(isChecked);

    }

    const handleSearch = () => {
        var searchPayload: WorkItemSearchCriteria = {
            contentType: contentTypes,
            resource: userId ?? '',
            status: workItemStatuses,
            workItemSearchText: workItem,
            workspaces: workspaces,
            resourceOnlyAsPrimary: onlyAsPrimaryResource,
            includeChildWorkItems: includeChildren,
            searchAll: true,
            userId: userId ?? '',
            responsibilities: workItemResponsibilities,
            responsibilityUseOrOperator: useOrOperator,
            matchOnPrimary: isPrimaryResource
        };
        props.onSearch(searchPayload);
    }

    return (
        <>
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemSearchFieldWorkItem
                    idSuffix={BulkUpdateModes[props.mode]}
                    canIncludeChilren={true}
                    onChange={e => setWorkItem(e.target.value)}
                    onChangeCheckbox={() => setIncludeChildren(!includeChildren)}
                />
            </Grid>
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemSearchFieldStatus
                    idSuffix={BulkUpdateModes[props.mode]}
                    onChange={statuses => setWorkItemStatuses(statuses)}
                    options={props.mode === BulkUpdateModes.Resources ? WorkItemResourcesSearchStatuses : WorkItemSearchStatuses} />
            </Grid>
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemSearchFieldWorkspace
                    idSuffix={BulkUpdateModes[props.mode]}
                    options={workitemLOVs?.workSpaces}
                    onChange={workspaces => setWorkspaces(workspaces)}
                />
            </Grid>
            {props.mode === BulkUpdateModes.Resources &&
                <Grid xs={1} sm={1} md={6} lg={4}>
                    <WorkItemSearchFieldResponsibility
                        idSuffix={BulkUpdateModes[props.mode]}
                        options={workitemLOVs?.responsibilities}
                        onChangeCheckbox={() => setUseOrOperator(!useOrOperator)}
                        onChange={responsibilities => setWorkItemResponsibilities(responsibilities)} />
                </Grid>
            }
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemSearchFieldResource
                    idSuffix={BulkUpdateModes[props.mode]}
                    onChange={onChangeResource}
                    onChangeCheckbox={() => setOnlyAsPrimaryResource(!onlyAsPrimaryResource)}
                    loadingResources={loadingResources}
                    errorResources={errorResources}
                    onKeyUp={e => setResource(e.target.value)}
                    resources={resources}
                    mode={props.mode}
                    isPrimaryChecked={isPrimaryResource}
                    onChangeIsPrimaryCheckbox={(checked: boolean) => handleIsPrimaryResource(checked)}
                />
            </Grid>
            <Grid xs={1} sm={1} md={6} lg={4}>
                <WorkItemSearchFieldContentType
                    idSuffix={BulkUpdateModes[props.mode]}
                    options={workitemLOVs?.contentTypes}
                    onChange={(contentTypes: SetStateAction<number[]>) => setContentTypes(contentTypes)} />
            </Grid>
            <Grid xs={1} sm={1} md={12} lg={12} my={'8px'}
                flexDirection='row-reverse'
                container>
                <Button
                    id={"bu-clear-grid-" + BulkUpdateModes[props.mode].toLocaleLowerCase()}
                    sx={{ marginRight: '10px' }}
                    variant="outlined"
                    onClick={props.onClearSearch}>Clear Grid</Button>
                <Button
                    id={"bu-search-" + BulkUpdateModes[props.mode].toLocaleLowerCase()}
                    sx={{ marginRight: '10px' }}
                    variant="contained"
                    disabled={WorkItemStatusLoading}
                    onClick={handleSearch}>Search</Button>
            </Grid>
        </>
    );
}

export default BulkUpdateSearch;